import {request} from "../../../api-client";

class Flowlike {

  initialize = () => { }

  pageView = () => { }

  exception = ({
    description,
  }) => {
    request.log(description, 'error').catch(() => {})
  }

  event = () => { }

}

export default Flowlike